import { render, staticRenderFns } from "./daily-statement-of-capital-account.vue?vue&type=template&id=68b0a390&"
import script from "./daily-statement-of-capital-account.vue?vue&type=script&lang=js&"
export * from "./daily-statement-of-capital-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports